import { useLocalization } from '@/Hooks';
import { ColumnInfo, ColumnType } from '@/Types';
import { EmailTemplateRow } from '@/Types/EmailTemplateRow';
import { useMemo } from 'react';

export function useEmailTemplatesTableColumnInfo() {
  const { emailTemplateColumns } = useLocalization();

  return useMemo<ColumnInfo<EmailTemplateRow>[]>(
    () => [
      { columnType: ColumnType.String, fieldName: 'guid', visible: false },
      { columnType: ColumnType.String, fieldName: 'name', headerText: emailTemplateColumns.Templates },
    ],
    [emailTemplateColumns],
  );
}
